import React from "react";
import Alert from "Components/Alert.js";
import Html from "Components/Html.js";
import scss from "./HopsOrgNoticeboardNotice.module.scss";

/**
 * Organisation blackboard
 *
 * @package HOPS
 * @subpackage NoticesHops
 * @author Heron Web Ltd
 * @copyright Heritage Operations Processing Limited
 */
class HopsOrgNoticeboardNotice extends React.PureComponent {

	/**
	 * Render.
	 * 
	 * @return {ReactNode}
	 */
	render() {
		return (
			<Alert
				className={scss.background}
				collapsible={true}
				title="Noticeboard"
				variant="warning"
				variantv="outlined">
				<Html className={scss.content} html={this.props.content} />
			</Alert>
		);
	}

}

export default HopsOrgNoticeboardNotice;
